import Hidden from '@mui/material/Hidden';
import { styled } from '@mui/material/styles';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import {
  navbarCloseFolded,
  navbarCloseMobile,
  navbarOpenFolded,
  selectABSNavbar,
} from 'app/store/abs/navbarSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectABSCurrentLayoutConfig } from 'app/store/abs/settingsSlice';
import NavbarStyle2Content from './NavbarStyle2Content';
import clsx from 'clsx';

const navbarWidth = 280;

const Root = styled('div')(({ theme, folded, stickynavbar }) => ({
  display: 'flex',
  flexDirection: 'column',
  zIndex: 4,
  [theme.breakpoints.up('lg')]: {
    width: navbarWidth,
    minWidth: navbarWidth,
  },
  ...(folded && {
    [theme.breakpoints.up('lg')]: {
      width: 76,
      minWidth: 76,
    },
  }),
  ...(stickynavbar && {
		maxHeight: "calc(100vh - 64px)"
	}),
}));

const StyledNavbar = styled('div')(
  ({ theme, position, folded, foldedandopened, foldedandclosed }) => ({
    minWidth: navbarWidth,
    width: navbarWidth,
    maxWidth: navbarWidth,
    maxHeight: '100%',
    transition: theme.transitions.create(['width', 'min-width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter,
    }),
		'& .NavbarStyle2-content': {
			'& .userwrapper, & .logowrapper, & .contentwrapper': {
				transition: theme.transitions.create('margin', {
					easing: theme.transitions.easing.easeOut,
					duration: theme.transitions.duration.leavingScreen
				}),
			},
		},
    ...(position === 'left' && {
      left: 0,
    }),

    ...(position === 'right' && {
      right: 0,
    }),

    ...(folded && {
      position: 'absolute',
      width: 76,
      minWidth: 76,
      top: 0,
      bottom: 0,
    }),

    ...(foldedandopened && {
      width: navbarWidth,
      minWidth: navbarWidth,
    }),

    ...(foldedandclosed && {
      '& .NavbarStyle2-content': {
        '& .logo-icon': {
          width: 44,
          height: 44,
        },
        '& .logo-text': {
          opacity: 0,
        },
        '& .react-badge': {
          opacity: 0,
        },
        '& .abs-list-item': {
          width: 56,
        },
        '& .abs-list-item-text, & .arrow-icon, & .item-badge': {
          opacity: 0,
        },
        '& .abs-list-subheader .abs-list-subheader-text': {
          opacity: 0,
        },
        '& .abs-list-subheader:before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          minWidth: 16,
          borderTop: '2px solid',
          opacity: 0.2,
        },
        '& .collapse-children': {
          display: 'none',
        },
        '& .user': {
          '& .username, & .email': {
            opacity: 0
          },
          '& .avatar': {
            width: 46,
            height: 46,
            bottom: 60,
            padding: 0
          }
        },
        '& .abs-list-item.active': {
          width: 54
        },
        '& .userwrapper': {
          marginTop: '-50px'
        },
        '& .contentwrapper': {
          marginTop: 0
        },
        '& .logowrapper': {
          marginTop: '-68px',
          opacity: 0
        },
        '& .navigation': {
          marginTop: '-45px'
        }
      },
    }),
  })
);

const StyledNavbarMobile = styled(SwipeableDrawer)(({ theme, position }) => ({
  '& > .MuiDrawer-paper': {
    minWidth: navbarWidth,
    width: navbarWidth,
    maxWidth: navbarWidth,
    maxHeight: '100%',
    transition: theme.transitions.create(['width', 'min-width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function NavbarStyle2(props) {
  const dispatch = useDispatch();
  const config = useSelector(selectABSCurrentLayoutConfig);
  const navbar = useSelector(selectABSNavbar);

  // const folded = !navbar.open;
  const { folded } = config.navbar;
  const foldedandclosed = folded && !navbar.foldedOpen;
  const foldedandopened = folded && navbar.foldedOpen;

  return (
    <Root
      folded={folded ? 1 : 0}
      open={navbar.open}
      id="abs-navbar"
      stickynavbar={config.navbar.belowheader ? 1 : 0}
      className={clsx(
        "h-screen shrink-0 z-40",
        config.toolbar.style === 'fixed' && "sticky",
        config.navbar.belowheader ? 'top-64' : 'top-0'
        )}
    >
      <Hidden lgDown>
        <StyledNavbar
          className="flex-col flex-auto shadow-5"
          position={config.navbar.position}
          folded={folded ? 1 : 0}
          foldedandopened={foldedandopened ? 1 : 0}
          foldedandclosed={foldedandclosed ? 1 : 0}
          onMouseEnter={() => foldedandclosed && dispatch(navbarOpenFolded())}
          onMouseLeave={() => foldedandopened && dispatch(navbarCloseFolded())}
        >
          <NavbarStyle2Content className="NavbarStyle2-content" />
        </StyledNavbar>
      </Hidden>

      <Hidden lgUp>
        <StyledNavbarMobile
          classes={{
            paper: 'flex-col flex-auto h-full',
          }}
          folded={folded ? 1 : 0}
          foldedandopened={foldedandopened ? 1 : 0}
          foldedandclosed={foldedandclosed ? 1 : 0}
          anchor={config.navbar.position}
          variant="temporary"
          open={navbar.mobileOpen}
          onClose={() => dispatch(navbarCloseMobile())}
          onOpen={() => {}}
          disableSwipeToOpen
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <NavbarStyle2Content className="NavbarStyle2-content" />
        </StyledNavbarMobile>
      </Hidden>
    </Root>
  );
}

export default NavbarStyle2;
